import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { LotteryInstallmentConfigurationModel } from "src/app/model/LotteryInstallmentConfigurationModel";
import { Page } from "src/app/model/Page";
import { PaymentSettlementModel } from "src/app/model/PaymentSettlementModel";
import { SchemeInstallmentConfigurationModel } from "src/app/model/SchemeInstallmentConfigurationModel";
import { InstallmentConfigService } from "src/app/services/installment-config.service";
import { MasterService } from "src/app/services/master.service";
import { OfficialsService } from "src/app/services/officials.service";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";
// import { PaymentSettlementService } from "src/app/services/payment-settlement.service";
import moment from 'moment';
import { DatePipe } from "@angular/common";
import { ExcelExportService } from "src/app/services/excel-export.service";
import * as XLSX from 'xlsx';


@Component({
  selector: "app-secure-new-payment-extension-list",
  templateUrl: "./new-payment-extension-list.component.html",
  styleUrls: ["./new-payment-extension-list.component.scss"],
})
export class NewPaymentExtensionListComponent implements OnInit {
  lotteryList: { [key: number]: string };
  loaded: boolean = false;

  totalElements: any = 0;

  isLoading = false;
  lotteries: { [key: number]: string };
  schemes: { [key: number]: string };
  installmentTypes: { [key: number]: string };
  lotteryInstallmentConfigs: LotteryInstallmentConfigurationModel[] = [];
  schemeInstallmentConfigs: SchemeInstallmentConfigurationModel[] = [];
  isSubmitDisabled: boolean = false;
  lotteryKey: { key: number; value: string };
  schemeKey: { key: number; value: string };
  isAddAllowedForLottery: boolean;
  isAddAllowedForScheme: boolean;
  otherInstallmentNames: string[];
  installmentType: string;
  installmentTypess: string;
  installmentSchemeType: string;
  schemeInstallment: { [key: number]: string };
  lotteryKeyNew: number;
  schemeKeyNew: number;
  listType: string;
  tableDataLoaded: boolean = false;
  isLoadingReport: boolean = false;

  page: Page<PaymentSettlementModel>;
  dataSource: MatTableDataSource<PaymentSettlementModel> = new MatTableDataSource();
  form: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  isAnyCheckboxSelected: boolean = false;
  lotterysName: { [key: number]: string };
  status: { [key: number]: string };
  selectedElement: PaymentSettlementModel[] = [];
  isAllSelected: boolean = false;
  selectedElements: PaymentSettlementModel[] = [];
  filterText: string;
  extensionListType: string;
  extendDays:number;
  intrestRate:number;
  selectedPolDate:string;
  selectedDueDate:string;
  remarks:string;
  response: any = {};
  selectedFile: File;


  
  isOverdue(dueDateString: string): boolean {
    const dueDate = new Date(dueDateString);
    const currentDate = new Date();
    return dueDate < currentDate;
  }
 
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "checkbox",
    "id",
    "applicationNo",
    "applicantName",
    "schemaCode",
    "intrestRate",
    "extIntrestRate",
    "applicationDrawStatus",
    // "eligibilityStatus",
    "dueDate",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  schemeList: {};
  orderDocumentFile: string | ArrayBuffer;

  constructor(
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private masterService: MasterService,
    private paymentSettlementService: PaymentSettlementService,
    private officialsService: OfficialsService,
    private installmentConfigService: InstallmentConfigService,
    private excelExportService: ExcelExportService


  ) { }

  ngOnInit(): void {
    this.loadData();
    this.form = new FormGroup({
      lotteryKey: new FormControl(null, Validators.required),
      lotterysName: new FormControl(null, Validators.required),
      schemeInstallment: new FormControl(null, Validators.required),
      lotteryInstallment: new FormControl(null, Validators.required),
      extensionListType: new FormControl(null, Validators.required),
      schemeKey: new FormControl(null, Validators.required),
      isAllSelected: new FormControl(null, Validators.required),
      drawStatus: new FormControl(null),
      filterText: new FormControl(null, [Validators.minLength(3),]),
      extendDays: new FormControl(null, [Validators.maxLength(3),]),
      intrestRate: new FormControl(null, [Validators.maxLength(5),]),
      polDateSelected: new FormControl(null),
      dueDateSelected: new FormControl(null),
      file2: new FormControl(null),
      remarks: new FormControl(null)

    });
    // this.form.controls["filterText"].setValue(null);
  }

  loadData() {
    this.isLoading = true;
    this.installmentConfigService.initInstallmentConfiguration().subscribe(
      (data) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.lotteries = data.lotteries;
          this.otherInstallmentNames = data.otherInstallmentNames;
        } else {
          this.installmentConfigService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.installmentConfigService.errorToast(
          error?.error?.message || error?.error?.errorMessage
        );
        // this.isLoading = false;
      }
    );
  }

  onListTypeChange(value: string) {
    this.extensionListType = value;
  }

  validateOrderDocFile() {
    return typeof this.orderDocumentFile === "string" ? true : false;
  }

  onCheckboxChange(row: PaymentSettlementModel) {
    if (row.isSelected) {
      this.isSubmitDisabled = false;
      // this.selectedElement = row;
      this.selectedElements.push(row);
      console.log("this.selectedElement", this.selectedElements);
    } else {
      // this.selectedElement = null;
      this.selectedElements = this.selectedElements.filter(
        (element) => element !== row
      );
    }
    this.isAnyCheckboxSelected = this.selectedElements.length > 0;

  }

  selectAll(event) {
    this.selectedElements = [];

    this.dataSource.data.forEach((element) => {
      element.isSelected = event.checked;
      if (element.isSelected) {
        this.selectedElements.push(element);
      }
    });

    this.isAllSelected = event.checked;
    this.isAnyCheckboxSelected = this.selectedElements.length > 0;
    console.log("this.isAllSelected", this.isAllSelected);
    console.log("this.selectedElements", this.selectedElements);
  }

  onLotteryChange(value: any) {
    this.form.get('dueDateSelected').patchValue(null);
    this.schemes = {};
    this.installmentTypes = {};
    this.lotteryInstallmentConfigs = [];
    this.schemeInstallmentConfigs = [];
    this.isAddAllowedForLottery = false;
    this.isAddAllowedForScheme = false;
    this.lotteryKeyNew = value?.key;
    this.schemeKey = null;
    this.form.get('extendDays').setValue(null);
    this.form.get('intrestRate').setValue(null);
    this.form.get('remarks').setValue(null);
    this.selectedElements = [];
    this.selectedFile=null;
    this.installmentType=null;
    this.tableDataLoaded=false;
    this.dataSource = new MatTableDataSource<PaymentSettlementModel>([]);
    if (value?.key > 0) {
      this.isLoading = true;
      this.installmentConfigService.initWithLotterySelect(value.key).subscribe(
        (data) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            this.schemes = data.schemes;
            this.installmentTypes = data.installmentTypes;
            console.log(" InstallmentConfiguration:", this.lotteryInstallmentConfigs);

            this.lotteryInstallmentConfigs =
              data.lotteryInstallmentConfigs.sort((a, b) => a.key - b.key);

            this.isAddAllowedForLottery = !(
              this.lotteryInstallmentConfigs &&
              this.lotteryInstallmentConfigs.length > 0
            );
          } else {
            this.installmentConfigService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.installmentConfigService.errorToast(
            error?.error?.message || error?.error?.errorMessage
          );
          this.isLoading = false;
        }
      );
    }
   
  }
  onSchemeChange(e: any) {
    this.schemeInstallmentConfigs = [];
    this.isAddAllowedForScheme = false;
     this.schemeKeyNew = e?.key;
     this.selectedElements = [];
     this.tableDataLoaded=false;
     this.form.get('extendDays').setValue(null);
     this.form.get('intrestRate').setValue(null);
     this.form.get('remarks').setValue(null);
     this.selectedFile=null;
     this.installmentType=null;
     this.dataSource = new MatTableDataSource<PaymentSettlementModel>([]);



    if (e?.key > 0) {
      this.isLoading = true;
      this.installmentConfigService
        .initWithSchemeSelect(this.lotteryKeyNew, e.key)
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.schemeInstallmentConfigs =
                data.schemeInstallmentConfigs.sort((a, b) => a.key - b.key);

              // this.isAddAllowedForScheme = !(
              //   this.schemeInstallmentConfigs &&
              //   this.schemeInstallmentConfigs.length > 0
              // );
            } else {
              this.installmentConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.installmentConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isLoading = false;
          }
        );
    }
  }

  loadAppicationListByLottery(lotteryInstallment: any) {
    this.listType = 'lotteryType';
    this.installmentType = lotteryInstallment.installmentType;
    this.selectedElements = [];
    this.selectedFile = null;
    this.onLoad();
  }

  loadAppicationListByScheme(schemeInstallment: any) {
    this.listType = 'schemeType';
    this.installmentType = schemeInstallment.installmentType;
    this.selectedElements = [];
    this.selectedFile = null;
    this.onLoad();
  }

  resetFilter() {
    window.location.reload();
    this.form.controls["filterText"].setValue(null);
    // this.filterForm.controls["status"].setValue(null);
    // this.filterForm.controls["lotterysName"].setValue(null);

    this.page = null;
    this.dataSource = new MatTableDataSource(null);
    setTimeout(() => {
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;
    });
  }
  onKeyPress(event: any) {
    return /[0-9,]/i.test(event.key);
  }
  onSearch() {
    const polDateSelected = this.form.value.polDateSelected;
    this.selectedPolDate = moment(polDateSelected).format('YYYY-MM-DD');

    const dueDateSelected = this.form.value.dueDateSelected;
    this.selectedDueDate = moment(dueDateSelected).format('YYYY-MM-DD');
   
    if (
      this.form.controls['lotterysName'].valid &&

      this.form.controls['schemeKey'].valid
    ) {
       if (this.form.controls['lotteryInstallment'].valid || this.form.controls['schemeInstallment'].valid) {
          this.isAllSelected = false;
          this.filterText = this.form.value.filterText;
          this.onLoad()
      } else {
        this.masterService.errorToast("Installment Type is Required !");

      }
    }
    else {
      this.masterService.errorToast("Lottery Name and Scheme Name is Required !");
    }
  }
    onLoad(currentPage?: number, totalElements?: any, callback?: any) {
    this.loaded = true;
    this.officialsService
      .getNewPaymentExtensionList(
        currentPage ? currentPage : this.currentPage,
        totalElements ? totalElements : this.pageSize,
        this.lotteryKeyNew,
        this.schemeKeyNew,
        this.installmentType,
         this.filterText,
         this.selectedDueDate

      )
      .subscribe(
        (page: any) => {
          this.loaded = false;
          console.log("Page ", page);

          if(!callback) {
            this.page = page;
            this.totalElements = page.totalElements;
            if (page.content[0] !== null) {
              this.dataSource = new MatTableDataSource(page.content);
              this.tableDataLoaded=true;
            } else {
              this.dataSource = new MatTableDataSource<PaymentSettlementModel>(
                []
              );
              this.loaded = false;
            }
  
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = page.totalElements;
            });
            this.isSearchDisabled = false;
          }
          else {
            callback(page);
          }
        },
        (error) => {
          this.loaded = false;

          console.log(error);
          this._snackBar.open("Payment Defaulter Details not Found", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
          });
          this.isSearchDisabled = false;
        }
      );
  }


  pageChanged(event: PageEvent) {
    console.log({ event });
    console.log(event.pageSize);
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onSearch();
  }
  
  onSubmit() {
   
      this.extendDays = this.form.value.extendDays;
      this.intrestRate=this.form.value.intrestRate;
      this.remarks=this.form.value.remarks;

      if (this.selectedElements.length === 0) {
        return this._snackBar.open(
          "Please select at least one Applicant Details",
          "Close",
          {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 10 * 1000,
          }
        );
      }
    
      if (!this.extendDays || !this.intrestRate) {        
        return this._snackBar.open(
          "Please enter values for Extend Days and Interest Rate",
          "Close",
          {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 10 * 1000,
          }
        );
      }
      if (!this.validateOrderDocFile()) {
        return this._snackBar.open("Order Document File Is Required", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 10 * 1000,
        });
      }
    
    this.isLoading = true;
    let applicationNumbers = this.selectedElements
      .map((obj) => obj.applicationNo)
      .join(", ");


    if (
      confirm("Do you want to allow to give extension to selected application numbers !")
    ) {
      this.paymentSettlementService
        .savePaymentExtension({
          installmentType:this.installmentType,
          extensionListType:this.extensionListType,
          applicationNo:applicationNumbers,
          extendDays: this.extendDays,
          intrestRate: this.intrestRate,
          remarks:this.remarks,
          orderDocumentFile: this.orderDocumentFile,
        })
        .subscribe((data) => {
          this.isLoading = false;
          this._snackBar.open("Save SuccessFully", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 10 * 1000,
          });
          this.onLoad();
          this.selectedElements = [];
          this.form.get('extendDays').setValue(null);
          this.form.get('intrestRate').setValue(null);
          this.form.get('remarks').setValue(null);
          this.selectedFile = null;
          const fileInput = document.getElementById('file2') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.dataSource = new MatTableDataSource<PaymentSettlementModel>([]);
            // this.resetFilter();
         
        });
       
      this.form.controls["approveRemark"].setValue(null);
      
    }
  }

  isPastDue(dueDate: string): boolean {
    const currentDate = new Date();
    const formattedDueDate = this.formatDate(dueDate);
    const dueDateObj = new Date(formattedDueDate);
  
    return dueDateObj < currentDate;
  }
  
  formatDate(dateString: string): string {
    const parts = dateString.split('-');
    return `${parts[1]}-${parts[0]}-${parts[2]}`;
  }

  onFileSelect(event) {
    
    if (event.target.files[0].size < 2 * 1024 * 1024) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile && this.selectedFile.type === "application/pdf") {
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.orderDocumentFile = reader.result;
          const fileNameParts = this.selectedFile.name.split(".");
          const fileNameWithoutExtension = fileNameParts[0];
        };
      } else {
        this.selectedFile = null;
        this.orderDocumentFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedFile = null;
      this.orderDocumentFile = null;

      this._snackBar.open("File size exceeds 2MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }

  fetchApplicantList() {
    if (this.totalElements && this.totalElements > 0) {
      this.exportToExcel(0, this.totalElements, (page) => {
      });
    }
  }
  
  extractDataForExcel(data: any[]) {
    if (!Array.isArray(data)) {
      console.error('Data is not an array');
      return []; 
    }
  
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  
    return data.map(item => ({
      ApplicationNo: item.applicationNo,
      ApplicantName: item.applicantName,
      SchemeCode: item.schemaCode,
      // EligibilityStatus: item.eligibilityStatus,
      BaseInterestRate: item.intrestRate,
      ExtInterestRate: item.extIntrestRate,
      DueDate: formatDate(item.dueDate),
      InstallmentType: this.installmentType

    }));
  }
  
  exportToExcel(startIndex: number, totalElements: any, callback: (page: any[]) => void) {
    const data = this.extractDataForExcel(this.page.content);

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const fileName = 'ApplicantList.xlsx';
  
    const saveAsExcelFile = (buffer: any, fileName: string) => {
      const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(data);
      downloadLink.download = fileName;
      downloadLink.click();
    };
  
    saveAsExcelFile(excelBuffer, fileName);
  }
     
}
